import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { AddDonationBatchHeaderModel } from '../../../models/AddDonationBatchHeaderModel';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-donation-batch-header',
  standalone: true,
  templateUrl: './donation-batch-header.component.html',
  imports: [CommonModule, CardModule, ButtonModule, RouterModule],
  styleUrls: ['./donation-batch-header.component.scss']
})
export class DonationBatchHeaderComponent {
  @Input() headerInfo!: AddDonationBatchHeaderModel;

  constructor(private router: Router) { }

  getBadgeDonationCountClass(): string {
    if (this.headerInfo.remainingAmount === 0) {
      return 'badge badge-success';
    } else {
      return 'badge badge-danger';
    }
  }

  getBadgeDonationAmountClass(): string {
    if (this.headerInfo.remaining === 0) {
      return 'badge badge-success';
    } else {
      return 'badge badge-danger';
    }
  }

  completeBatch() {
    this.router.navigate(['/vortex/donations/donation-batches']);
  }

}

